<template>
  <base-content-block>
    <template #title>
      {{ title }}
    </template>
    <template #content>
      <patient-form v-model="patient" :saving="saving" @submit="save"></patient-form>
      <base-modal
        :is-show="isShowCreateCourseModal"
        @close="closePatientAdding"
        @cancel="closePatientAdding"
        @confirm="goToCreateCourse"
      >
        <template #header>{{ $t('src/pages/patientadd.3399') }}</template>
        <template #body>{{ $t('src/pages/patientadd.1135') }}</template>
      </base-modal>
    </template>
  </base-content-block>
</template>

<script>
import http from '@/modules/http.js'
import { contentTpl } from '@/mixins/content-tpl.js'
import { systemUnavailable } from '@/mixins/system-unavailable.js'

export default {
  name: 'PatientAdd',
  mixins: [contentTpl, systemUnavailable],
  components: {
    PatientForm: () => import('@/components/PatientForm.vue'),
    BaseModal: () => import('@/base/BaseModal.vue')
  },
  data: () => ({
    patient: {},
    saving: false,
    isShowCreateCourseModal: false
  }),
  methods: {
    save() {
      this.saving = true

      http
        .post('/patients', this.patient)
        .then(response => {
          if (response.data.id) {
            return response.data.id
          } else {
            throw this.$t('errorMessage.unexpectedError')
          }
        })
        .then(id => {
          this.patient.id = id
          this.isShowCreateCourseModal = true
        })
        .catch(error => {
          if (error.response.data.message === 'The system has expired') {
            this.$emit('system:unavailable')
          }
          console.log(error)
        })
        .finally(() => {
          this.saving = false
        })
    },
    closeCreateCourseModal() {
      this.isShowCreateCourseModal = false
    },
    closePatientAdding() {
      this.closeCreateCourseModal()
      this.$router.push({
        name: 'patients'
      })
    },
    goToCreateCourse() {
      this.$router.push({
        name: 'course-add',
        query: { patient: this.patient.id }
      })
    }
  }
}
</script>
